var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub_header"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"back_btn",on:{"click":_vm.RouterBack}},[_c('a')])])
}
var staticRenderFns = []

export { render, staticRenderFns }